let blogStorage = [
{
id:1,
title:"AI in Healthcare Revolution",
slug:"ai-in-healthcare-revolution",
description:"How AI is transforming healthcare.",
author:"Safiya Naaz",
date:"2026-03-10",
image:"https://images.unsplash.com/photo-1576091160550-2173dba999ef",
content:"<p>AI is transforming healthcare systems worldwide.</p>"
},
{
id:2,
title:"Python for Data Science",
slug:"python-for-data-science",
description:"Why Python dominates the data science world.",
author:"Admin",
date:"2026-03-05",
image:"https://images.unsplash.com/photo-1515879218367-8466d910aaa4",
content:"<p>Python provides powerful libraries like Pandas and NumPy.</p>"
},
{
id:3,
title:"Python for Data Science",
slug:"python-for-data-science",
description:"Why Python dominates the data science world.",
author:"Admin",
date:"2026-03-05",
image:"https://images.unsplash.com/photo-1515879218367-8466d910aaa4",
content:"<p>Python provides powerful libraries like Pandas and NumPy.</p>"
},
{
id:4,
title:"Python for Data Science",
slug:"python-for-data-science",
description:"Why Python dominates the data science world.",
author:"Admin",
date:"2026-03-05",
image:"https://images.unsplash.com/photo-1515879218367-8466d910aaa4",
content:"<p>Python provides powerful libraries like Pandas and NumPy.</p>"
},
{
id:5,
title:"Python for Data Science",
slug:"python-for-data-science",
description:"Why Python dominates the data science world.",
author:"Admin",
date:"2026-03-05",
image:"https://images.unsplash.com/photo-1515879218367-8466d910aaa4",
content:"<p>Python provides powerful libraries like Pandas and NumPy.</p>"
},
{
id:6,
title:"Python for Data Science",
slug:"python-for-data-science",
description:"Why Python dominates the data science world.",
author:"Admin",
date:"2026-03-05",
image:"https://images.unsplash.com/photo-1515879218367-8466d910aaa4",
content:"<p>Python provides powerful libraries like Pandas and NumPy.</p>"
},
{
id:7,
title:"Python for Data Science",
slug:"python-for-data-science",
description:"Why Python dominates the data science world.",
author:"Admin",
date:"2026-03-05",
image:"https://images.unsplash.com/photo-1515879218367-8466d910aaa4",
content:"<p>Python provides powerful libraries like Pandas and NumPy.</p>"
},
{
id:8,
title:"Python for Data Science",
slug:"python-for-data-science",
description:"Why Python dominates the data science world.",
author:"Admin",
date:"2026-03-05",
image:"https://images.unsplash.com/photo-1515879218367-8466d910aaa4",
content:"<p>Python provides powerful libraries like Pandas and NumPy.</p>"
}
]

let blogs = [...blogStorage]

export const getBlogs = () => {
  return blogs
}

export const saveBlogs = (updatedBlogs) => {
  blogs = updatedBlogs
}

const deleteBlog = (id) => {

const blogs = getBlogs()

const updated = blogs.filter(b => b.id !== id)

saveBlogs(updated)

}

blogs = getBlogs()

const newBlog = {
id: Date.now(),
title: "New Blog",
slug: "new-blog"
}

blogs.push(newBlog)

saveBlogs(blogs)

export default blogStorage;